import { render, staticRenderFns } from "./EditUserComponent.vue?vue&type=template&id=54cdcb02"
import script from "./EditUserComponent.vue?vue&type=script&lang=js"
export * from "./EditUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports